import { z } from "zod";

const NAME_PATTERN = /^[a-zA-Z'-]+[a-zA-Z\s'-]*$/;

const nameSchema = (label: string) =>
  z
    .string()
    .trim()
    .nonempty(`${label} is required.`)
    .max(255, `${label} must be 255 characters or fewer.`)
    .regex(
      NAME_PATTERN,
      `${label} must contain only letters, spaces, apostrophes, or hyphens.`,
    )
    .regex(/[a-zA-Z]/, `${label} must contain at least one letter.`);

export const addUserSchema = z.object({
  firstName: nameSchema("First name"),
  lastName: nameSchema("Last name"),
  email: z
    .string()
    .trim()
    .nonempty("Email address is required.")
    .email("Enter a valid email address.")
    .max(255, "Email address must be 255 characters or fewer."),
});

export type AddUserFormData = z.infer<typeof addUserSchema>;
